// extracted by mini-css-extract-plugin
export default {"field":"phone_field__X8k14","label":"phone_label__nKNRY","shell":"phone_shell__+cfmp","prefix":"phone_prefix__5hxUH","input":"phone_input__k0rUS"};